var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-list" },
    [
      _c("div", { staticClass: "yj-sheet-query" }, [
        _c(
          "header",
          { staticClass: "header wrapper" },
          [
            _c("span", { staticClass: "query-label" }, [_vm._v("模板名称：")]),
            _c("el-input", {
              staticStyle: { width: "200px" },
              attrs: {
                size: "mini",
                placeholder: "请输入模板名称",
                clearable: "",
              },
              model: {
                value: _vm.templateName,
                callback: function ($$v) {
                  _vm.templateName = $$v
                },
                expression: "templateName",
              },
            }),
            _c("span", { staticClass: "query-label" }, [_vm._v("创建人：")]),
            _c(
              "el-select",
              {
                attrs: {
                  filterable: "",
                  clearable: "",
                  placeholder: "选择创建人",
                  size: "mini",
                },
                model: {
                  value: _vm.createrId,
                  callback: function ($$v) {
                    _vm.createrId = $$v
                  },
                  expression: "createrId",
                },
              },
              _vm._l(_vm.userList, function (u, i) {
                return _c("el-option", {
                  key: i,
                  attrs: { label: u.nickName, value: u.id },
                })
              }),
              1
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", plain: "", size: "mini" },
                on: { click: _vm.handleSearch },
              },
              [_vm._v("查询")]
            ),
            _c("div", { staticClass: "yj-query-r" }, [
              _c(
                "span",
                {
                  staticClass: "yj-blue-btn",
                  on: {
                    click: function ($event) {
                      return _vm.openCreate("btn")
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-plus",
                    staticStyle: { "margin-right": "4px" },
                  }),
                  _vm._v("创建新的模板 "),
                ]
              ),
            ]),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "main wrapper" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "data-container",
          },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.dataList, size: "normal" } },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "模板名称",
                    prop: "templateName",
                    "min-width": "200",
                  },
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "阅卷方式" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.isHenCode ? "有痕阅卷" : "网络阅卷"
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "年级", prop: "gradeName" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.isAdmin(scope.row)
                            ? _c(
                                "el-dropdown",
                                {
                                  key: "grade" + scope.row.id,
                                  on: {
                                    command: function ($event) {
                                      return _vm.updateGrade($event, scope.row)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#2877FF" } },
                                    [
                                      _vm._v(
                                        " " + _vm._s(scope.row.gradeName) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown",
                                    },
                                    _vm._l(
                                      _vm.gradeList,
                                      function (opt, index) {
                                        return _c(
                                          "el-dropdown-item",
                                          {
                                            key: index,
                                            attrs: { command: opt.id },
                                          },
                                          [_vm._v(_vm._s(opt.gradeName))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c("span", [_vm._v(_vm._s(scope.row.gradeName))]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "学科",
                    prop: "subjectName",
                  },
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "栏数", prop: "columnNum" },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    width: "150",
                    label: "客观题/主观题数量",
                    prop: "objectiveQuestionNum",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(scope.row.objectiveQuestionNum) +
                              "/" +
                              _vm._s(scope.row.subjectiveQuestionNum) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "创建人",
                    prop: "createrName",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "创建时间",
                    width: "150",
                    prop: "createTime",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            _vm._s(_vm._f("formatDate")(scope.row.createTime))
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "操作", "min-width": "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "operate" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "normal" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.taskDetail(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("查看")]
                                ),
                                _vm.isAdmin(scope.row)
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "normal" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.update(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("编辑")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "normal" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copy(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("复用")]
                                ),
                              ],
                              1
                            ),
                            _vm.isAdmin(scope.row)
                              ? _c(
                                  "div",
                                  [
                                    _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            scope.row.isOpen
                                              ? "已公开"
                                              : "已隐藏"
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("el-switch", {
                                      on: {
                                        change: function ($event) {
                                          return _vm.changeOpenStates(scope.row)
                                        },
                                      },
                                      model: {
                                        value: scope.row.isOpen,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "isOpen", $$v)
                                        },
                                        expression: "scope.row.isOpen",
                                      },
                                    }),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { color: "#333333" },
                                        attrs: { type: "text", size: "normal" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delTemplate(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination" },
              [
                _c("zj-pagination", {
                  attrs: {
                    page: {
                      current: _vm.currentPage,
                      size: _vm.pageSize,
                      total: _vm.total,
                    },
                  },
                  on: { "current-change": _vm.handleCurrentChange },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: "选择年级和学科",
            visible: _vm.newVisible,
            width: "500px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "before-close": _vm.closeCreate,
          },
          on: {
            "update:visible": function ($event) {
              _vm.newVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { padding: "0 30px" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "年级：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "250px" },
                      attrs: { "value-key": "id", placeholder: "请选择年级" },
                      model: {
                        value: _vm.grade,
                        callback: function ($$v) {
                          _vm.grade = $$v
                        },
                        expression: "grade",
                      },
                    },
                    _vm._l(_vm.gradeList, function (g, i) {
                      return _c("el-option", {
                        key: i,
                        attrs: { label: g.gradeName, value: g },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "学科：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "250px" },
                      attrs: { placeholder: "请选择学科" },
                      model: {
                        value: _vm.subjectCode,
                        callback: function ($$v) {
                          _vm.subjectCode = $$v
                        },
                        expression: "subjectCode",
                      },
                    },
                    _vm._l(_vm.subjectList, function (s, i) {
                      return _c("el-option", {
                        key: i,
                        attrs: { label: s.dicName, value: s.dicCode },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "模板：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "250px" },
                      attrs: { placeholder: "请选择模板" },
                      model: {
                        value: _vm.templateId,
                        callback: function ($$v) {
                          _vm.templateId = $$v
                        },
                        expression: "templateId",
                      },
                    },
                    _vm._l(_vm.templateList, function (t, i) {
                      return _c("el-option", {
                        key: i,
                        attrs: { label: t.templateName, value: t.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.closeCreate } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.createNew },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: "请输入复用的答题卡名称",
            visible: _vm.reuseVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.reuseVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { padding: "0 30px" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "答题卡名称：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "250px" },
                    model: {
                      value: _vm.reuseName,
                      callback: function ($$v) {
                        _vm.reuseName = $$v
                      },
                      expression: "reuseName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.reuseVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.reuseTemplate },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }